import { render } from "./StockReports.vue?vue&type=template&id=4cceac2a"
import script from "./StockReports.vue?vue&type=script&lang=js"
export * from "./StockReports.vue?vue&type=script&lang=js"

import exportComponent from "/builds/weborigo-projects/vivien-vance/core-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__